export default "__VITE_ASSET__Dcls8v1l__"